// extracted by mini-css-extract-plugin
module.exports = {"game_card":"style_game_card__snMSW","game_card_desktop":"style_game_card_desktop__GVEDg"};